import { hash } from 'rsvp';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import type ActionAssignmentRulesController from 'uplisting-frontend/pods/action-assignment-rules/controller';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default class ActionAssignmentRulesRoute extends PermittedRoute {
  @service featureFlags!: Services['feature-flags'];

  @service('repositories/assignment-rule')
  assignmentRuleRepository!: Services['repositories/assignment-rule'];

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  permission = 'account.team';

  async beforeModel(transition: Transition): Promise<void> {
    await super.beforeModel(transition);

    if (transition.isAborted) {
      return;
    }

    if (!this.featureFlags.gate.enabled('task_centre')) {
      this.router.replaceWith('action');
    }
  }

  model() {
    return hash({
      rules: this.assignmentRuleRepository.findAll(),
      properties: this.propertyRepository.findAll(),
      changeoverSettings: this.store.findAll('changeover-setting'),
    });
  }

  resetController(
    controller: ActionAssignmentRulesController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    this.assignmentRuleRepository.unloadAll();
    this.store.unloadAll('changeover-setting');

    Object.assign(controller, { query: '', rulesFilter: 'all' });
  }
}
